/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioDivisionesTiposPropiedadesCV from './controladorVista/formularioDivisionesTiposPropiedadesCV';
import TablaDivisionesTiposPropiedadesCV from './controladorVista/tablaDivisionesTiposPropiedadesCV';
import { estadoIncial, reductor } from './reductorDivisionesTiposPropiedades';

const DivisionesTiposPropiedades: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaDivisionesTiposPropiedadesCV />
        <FormularioDivisionesTiposPropiedadesCV />
    </ProveedorEstado>
);

export default DivisionesTiposPropiedades;
